import React from 'react'
import { Helmet } from 'react-helmet-async'
import bandPhoto from '../images/NP/newpurple4.png'
import { useEffect } from 'react'

const Tour = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://widgetv3.bandsintown.com/main.min.js'
    script.charset = 'utf-8'
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])
  return (
    <div className="bg-gray-100">
      <Helmet>
        <title>The Non-Prophets - Tour</title>
        <meta
          name="description"
          content="Asheville Mountain Boys Tour Dates."
        />
        <link rel="canonical" href="/Tour" />
      </Helmet>
      <header className="h-screen/3 overflow-hidden pt-20 md:pt-0 ">
        <div className="relative">
          <img
            src={bandPhoto}
            alt="The Asheville Mountain Boys photo"
            className="w-full h-[35vh] md:h-[50vh] object-cover object-[50%_15%] opacity-50"
          />

          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <h1 className="text-gray-800 text-2xl md:text-3xl tracking-widest">
              Tour
            </h1>
          </div>
        </div>
      </header>
      <div>
        <script
          charset="utf-8"
          src="https://widgetv3.bandsintown.com/main.min.js"
        ></script>
        <a
          class="bit-widget-initializer"
          data-artist-name="id_853623"
          data-app-id="4ffdea72c18ff9b9fd97c95e7fe0a8ad"
        ></a>
      </div>
    </div>
  )
}

export default Tour
